
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/[apiKey]/multiProductCalendar",
      function () {
        return require("private-next-pages/embed/[apiKey]/multiProductCalendar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/[apiKey]/multiProductCalendar"])
      });
    }
  